/**
 * 模版市场-企业专区空白提示
 * @author VenDream
 * @since 17/11/13
 */

import React from 'react';

import emptyTplTips from 'assets/images/empty-tpl.svg';

export default function OrgEmptyTips() {
  return (
    <div className="org-empty">
      <img src={emptyTplTips} alt="EMPTY_TIPS" className="tips-img" />
      <div className="tips">
        <p className="tips-s-text">这里是空的哦</p>
        <p className="tips-b-text">赶紧让管理员共享精彩模版吧!</p>
      </div>
    </div>
  );
}
